import React from 'react';
import {
	type ExtraField,
	isExtraFieldDate,
	isExtraFieldHtml,
	isExtraFieldLabel,
	isExtraFieldText,
	isExtraFieldThumbnail,
} from '../../../../../model/extra-fields/types';
import { DateField } from './date-field';
import { HtmlField } from './html-field';
import { LabelsField } from './labels-field';
import { TextField } from './text-field';
import { ThumbnailField } from './thumbnail-field';

type Props = { field: ExtraField; isLite?: boolean };

export function CardExtraField({ field, isLite }: Props) {
	if (isExtraFieldThumbnail(field)) {
		return <ThumbnailField field={field} />;
	}

	if (isExtraFieldLabel(field)) {
		return <LabelsField field={field} isLite={isLite} />;
	}

	if (isExtraFieldHtml(field)) {
		return <HtmlField field={field} />;
	}

	if (isExtraFieldDate(field)) {
		return <DateField field={field} />;
	}

	if (isExtraFieldText(field)) {
		return <TextField field={field} />;
	}

	return null;
}
